module.exports = __webpack_public_path__ + "static/img/18.c47c412d.gif";